/* eslint-disable prefer-rest-params */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
export const addDataLayer = () => {
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
};
